const User = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99959 1.875C7.81347 1.875 6.04126 3.64721 6.04126 5.83333C6.04126 8.01946 7.81347 9.79167 9.99959 9.79167C12.1857 9.79167 13.9579 8.01946 13.9579 5.83333C13.9579 3.64721 12.1857 1.875 9.99959 1.875ZM7.29126 5.83333C7.29126 4.33756 8.50382 3.125 9.99959 3.125C11.4954 3.125 12.7079 4.33756 12.7079 5.83333C12.7079 7.3291 11.4954 8.54167 9.99959 8.54167C8.50382 8.54167 7.29126 7.3291 7.29126 5.83333Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.2628 11.0417C6.1555 11.0417 5.13087 11.6276 4.56938 12.582L4.0179 13.5194C3.58264 14.2592 3.39592 15.1232 3.57418 15.8998C3.76022 16.7104 4.33659 17.3709 5.27985 17.6146C7.91416 18.2951 12.0853 18.2951 14.7196 17.6146C15.6629 17.3709 16.2392 16.7104 16.4253 15.8998C16.6035 15.1232 16.4168 14.2592 15.9816 13.5194L15.4301 12.582C14.8686 11.6276 13.844 11.0417 12.7367 11.0417H7.2628ZM5.64675 13.2159C5.98365 12.6433 6.59842 12.2917 7.2628 12.2917H12.7367C13.401 12.2917 14.0158 12.6433 14.3527 13.2159L14.9042 14.1532C15.2141 14.6801 15.2991 15.2189 15.207 15.6202C15.1226 15.9877 14.8866 16.2804 14.4069 16.4043C11.9777 17.0319 8.02174 17.0319 5.59251 16.4043C5.11287 16.2804 4.87683 15.9877 4.7925 15.6202C4.70038 15.2189 4.78532 14.6801 5.09527 14.1532L5.64675 13.2159Z"
      fill="currentColor"
    />
  </svg>
);

export default User;
